import {createGa4FilterRemovedEvent, pushTag} from '../../script/analytics';

(function () {
    const facetNavButtons = $('.facet__list.applied-filters li button');
    for (const facetNavButton of facetNavButtons) {

        facetNavButton.addEventListener('click', () => {
            const filterValue = $(facetNavButton).find('.facet-nav.facet-value').first().text();
            const filterName = $(facetNavButton).find('.facet-nav.facet-name').first().text();
            const navUrl = $(facetNavButton).attr('data-facet-nav-url');
            let isProduct = true;
            if (navUrl.includes('downloadcenter')) {
                isProduct = false;
            }
            pushTag(createGa4FilterRemovedEvent('Filter Removed', filterName + '::' + filterValue, isProduct ? 'Product Filter' : 'Document Filter'));

            if (navUrl) {
                window.location.href = navUrl;
            }
        });
    }
})();
